import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { ENCRYPTED_DATA } from 'src/app/secure-data/encrypted-data';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  // private jsonUrl = 'assets/encrypted-data.json';

  constructor(private http: HttpClient) {}

  getEncryptedData(): Observable<any> {
    return this.http.get('assets/encrypted-data.json').pipe(
      tap((data: any) => Object.assign(ENCRYPTED_DATA, data))
    );
  }
}